import { APP_BASE_PATH } from './index'

export const TITLE =
  'Debt Relief Program: Get Debt Help Now | Freedom Debt Relief'
export const DESCRIPTION =
  'Learn what debt relief is, how it works, and compare options like debt settlement and debt consolidation. See pros, costs, and how to get started.'

export const URL = APP_BASE_PATH()

export default {
  title: TITLE,
  description: DESCRIPTION,
  canonical: URL,
  openGraph: {
    title: TITLE,
    description: DESCRIPTION,
    url: URL,
    images: [
      {
        url: 'https://freedomdebtrelief.com/next-assets/alejandra_hero_1599x531.webp',
        width: 800,
        height: 600,
        alt: 'Freedom Debt Relief Client',
      },
    ],
    site_name: 'Freedom Debt Relief',
    type: 'article',
    article: {
      authors: ['https://www.facebook.com/freedomdebtrelief'],
    },
  },
}
